import { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './QuestPage.module.css'; // CSS Module import
import { useNavigate } from 'react-router-dom'; // useNavigate 가져오기

import { format } from 'date-fns'; // date-fns에서 format 함수 임포트

import BACKBTN from '../../assets/BACKBTN.svg'; // 로고 이미지 import

// //// 하단바 내용
// import Navbar from '../all_pages/Navbar'; // 네비게이션 불러오기

const QuestPage = () => {
  const navigate = useNavigate();  // 네비게이션 함수
  const [topSkills, setTopSkills] = useState([]);
  const [randomQuests, setRandomQuests] = useState([]); 
  const [inProgressQuests, setInProgressQuests] = useState([]); // 진행 중인 퀘스트 상태 추가
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState('available'); // 기본 탭 '시작 가능'

  const [activeQuest, setActiveQuest] = useState(null);  // 클릭된 퀘스트 인덱스를 저장하는 상태

  const [questDetails, setQuestDetails] = useState({}); // 퀘스트 상세 정보 상태

  const [showModal, setShowModal] = useState(false); // 모달창 상태 추가
  const [selectedQuestId, setSelectedQuestId] = useState(null); // 선택된 퀘스트 저장

  const [viewQuestDetail, setViewQuestDetail] = useState(false); // 퀘스트 세부 정보 보기 상태
  const [selectedQuestDetails, setSelectedQuestDetails] = useState(null); // 선택된 퀘스트의 세부 정보 저장

  const [completedQuests, setCompletedQuests] = useState([]);
  const [selectedCompletedQuest, setSelectedCompletedQuest] = useState(null); // 선택된 완료된 퀘스트 상태

  const [modalContent, setModalContent] = useState(null); // 결과 내용 모달창 내용
  const [showReviewModal, setShowReviewModal] = useState(false); // 결과 보기 모달 상태


  const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기

  

  // 상위 스킬 가져오기 및 퀘스트 로직
  useEffect(() => {
    const fetchTopSkillsAndQuests = async () => {
      try {
        // 상위 스킬 가져오기
        const skills = await fetchTopSkills();
        console.log("Fetched skills:", skills); // skills 데이터 구조 확인
  
        setTopSkills(skills);
  
        // 각 스킬에 따른 퀘스트 중 하나씩 가져오기
        const quests = skills.map(skill => {
          const skillName = Array.isArray(skill) ? skill[0] : skill; // 스킬 이름만 추출
          return getRandomQuest(skillName); // 스킬에 맞는 퀘스트 목록 중 하나 선택 (스킬 이름만 전달)
        });
  
        setRandomQuests(quests); // 선택된 퀘스트를 상태에 저장
        console.log("Selected random quests:", quests); // 선택된 랜덤 퀘스트 로그 출력
  
        setLoading(false);
      } catch (error) {
        console.error("Error fetching skills and quests:", error);
        setLoading(false);
      }
    };
  
    fetchTopSkillsAndQuests();
  }, []);
  

  // 진행 중인 퀘스트 데이터를 불러오는 useEffect
  useEffect(() => {
    const loadInProgressQuests = async () => {
      if (activeTab === 'inprogress') {
        setLoading(true);
        const quests = await fetchInProgressQuests();  // 데이터를 받아옴
        setInProgressQuests(quests);  // 상태에 저장
        setLoading(false);
      }
    };
    
    loadInProgressQuests();
  }, [activeTab]);  // activeTab이 변경될 때마다 데이터를 가져옴

  useEffect(() => {
    // 완료된 퀘스트 데이터 불러오기
    const fetchCompletedQuests = async () => {
      const token = localStorage.getItem('accessToken'); // 토큰을 로컬 스토리지에서 가져오기
      
      if (!token) {
        console.error('Access token not found');
        return;
      }
    
      try {
        const response = await axios.get(`${apiUrl}/quest/completed/`, {
          headers: {
            Authorization: `Bearer ${token}`, // accessToken을 헤더에 포함
          },
        });
        
        setCompletedQuests(response.data); // 퀘스트 데이터 설정
        console.log('Completed quests fetched successfully:', response.data);
      } catch (error) {
        console.error('Error fetching completed quests:', error);
      }
    };
  
    fetchCompletedQuests(); // 완료된 퀘스트 가져오기 함수 호출
  }, []);  // 페이지 로드 시 한 번 호출
  





  // user_id 확인용 함수
const getUserIdFromLocalStorage = () => {
  const userId = localStorage.getItem('user_id');
  if (userId) {
    console.log("User ID from localStorage:", userId); // 콘솔에 user_id 출력
    return userId;
  }
  console.error("User ID not found in localStorage");
  return null;
};


// 상위 3가지 유형을 가져오는 함수
const fetchTopSkills = async () => {
  const cachedSkills = localStorage.getItem('topSkills');
  const cacheTime = localStorage.getItem('cacheTime');
  const now = new Date().getTime();

  if (cachedSkills && cacheTime && (now - cacheTime < 3600000)) {
    const parsedSkills = JSON.parse(cachedSkills);
    if (Array.isArray(parsedSkills) && parsedSkills.length > 0) {
      return parsedSkills;
    }
  }

  const token = localStorage.getItem('accessToken');
  try {
    const response = await axios.get(`${apiUrl}/aptitude_test/user-top-skills/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const topSkills = response.data;
    if (Array.isArray(topSkills) && topSkills.length > 0) {
      localStorage.setItem('topSkills', JSON.stringify(topSkills));
      localStorage.setItem('cacheTime', now);
      return topSkills;
    } else {
      console.error("No valid skills data received.");
      return [];
    }
  } catch (error) {
    console.error('Error fetching top skills:', error);
    return [];
  }
};

  // 각 스킬에 맞는 퀘스트 목록을 반환하는 함수
  const getRandomQuest = (skill) => {
    let quests = [];
    switch (skill) {
      case 'physical_skills':
        quests = ['연극하기', '자전거 타기', '수영하기', '구기 운동하기', '스트레칭하기', '댄스나 율동 익히기', '조깅하기', '계단 오르내리기', '50M 달리기', '등산하기'];
        break;
      case 'dexterity_skills':
        quests = ['뜨개질하기', '컴퓨터 분해하고 조립하기', '그림그리기', '일상용품 만들기', '캘리그래피 하기', '종이접기','흙으로 도자기 만들기','음식 만들기', '액세서리 만들기','선물 포장하기']; 
        break;
      case 'spatial_perception_skills':
        quests = ['약도 이용하여 길찾기','앞면보고 옆, 뒤, 밑면 그리기','사물 그리기','지도 그리기','그림자 모양 유추하기','입체도형의 전개도 그리기','무게의 중심점을 찾아 균형 맞추기','퍼즐 맞추기','3차원 조각 맞추기','별의 위치 찾기']; 
        break;
      case 'musical_skills':
        quests = ['상황에 적합한 음악 선정해보기','작사 작곡하기','오페라 듣기','화음 맞춰보기','학습내용 노래로 만들어 보기','음악을 듣고 그대로 연주하기','음악을 듣고 악기 구별해보기','명곡 감상하기','비트 만들기','악기 연주하기']; 
        break;
      case 'creativity_skills':
        quests = ['자율 연기 하기','제품을 보며 아이디어 추가','어떤 한 교과에서 쓰이는 원리를 다른 교과에 적용하기','아이디어를 기록하는 창의노트 만들기','서로 관련없는 그림이나 문장 및 단어 등으로 이야기 만들기','소설 끝 부분 창작하기','한 가지 주제에 대해 아이디어 쏟아내기','아이디어 단순화 하기','사진 찍어 동화책 만들기','하나의 사물을 다른 용도로 변형 시켜보기']; 
        break;
      case 'linguistic_skills':
        quests = ['강의 듣고 요약하기','독서 감상문 기록하기','보고서 기록하기','뉴스 한 토막을 통하여 신문기사 작성하기 ','토론하기','친구에게 영화나 책의 줄거리 이야기하기','글 분석하기','여러 가지 언어 비교해 보기 ','어려운 단어 쉽게 설명하기','주제 단어를 제시하고 관련된 마인드맵 작성하기']; 
        break;
      case 'logical_skills':
        quests = ['주변상황에서 일어날 수 있는 사건의 확률 계산하기','일상생활에서 수학적 원리 알아내기','수학 토론 하기','추리소설 읽기','나열된 숫자나 그림의 규칙 찾기','주어진 문제 해결 과정을 살펴보고 오류 발견하기','도표 만들기','그래프 분석하기','삼단논법 만들기','이미 일어난 사건들을 통하여 앞으로 일어날 사건 유추하기']; 
        break;
      case 'self_reflection_skills':
        quests = ['명상하기','하루를 마무리하는 일기 쓰기 ','내 행동이나 가치관이 보편적인 도덕적 기준에 맞는지 생각하기','다른 사람에게 나에 대한 피드백 받기','자신의 상황과 가장 비슷한 처지에 있는 소설 속 인물을 찾아 대응 방식 확인하기','매일 해야 할 일들을 실천하고 확인하기','장단기 목표 세우고 실천하기']; 
        break;
      case 'interpersonal_skills':
        quests = ['친구끼리 칭찬하기','봉사활동하기','공동 작업하기 ','자신의 행동이나 말에 따라 달라지는 사람들의 반응 살피기','돌아가면서 모둠 활동에서 조장 역할하기']; 
        break;
      case 'enviromental_friendliness_skills':
        quests = ['동,식물과 인간과의 관계 알아보기', '환경단체 활동 해보기', '쓰레기를 재활용 할 수 있는 방법 생각해보기', '동.식물 특징 파악하기', '동,식물이름 찾아보기','환경오염에 대한 공부하기','동.식물을 길러보고 일지 기록하기','동.식물 분류하기','기온의 변화에 따른 주변 식물 관찰','친구들과 같은 화분을 길러보기']; 
        break;
      case 'artistic_visual_skills':
        quests = ['수업내용 그림으로 표현하기','주위 사람들에게 가장 잘 어울리는 색깔 찾아주기','미술 작품 감상하기','독서 내용을 그림으로 표현하기','교실에 있는 물건을 최대한 활용하여 연극에 필요한 소품 만들기','1분 동안 대상을 관찰한 뒤 기억력을 바탕으로 그대로 그려내기','개성을 표현하여 패션쇼 하기','사물 디자인하기','공간 인테리어 바꾸어보기','다른 사람의 패션 코디해주기']; 
        break;
      // 다른 스킬 유형 추가
      // ...
      default:
        console.log(`Unknown skill type: ${skill}`);
        break;
    }
    // 랜덤으로 하나의 퀘스트 선택
    // return quests[Math.floor(Math.random() * quests.length)];
    if (quests.length > 0) {
      return quests[Math.floor(Math.random() * quests.length)];
    } else {
      return null;
    }
  };

    // 사용자가 수행 중인 퀘스트인지 확인하는 함수 (필터링)
    const isQuestInProgress = (quest) => {
        const userQuestLog = JSON.parse(localStorage.getItem('userQuestLog')) || [];
        return userQuestLog.some(log => log.quest_title === quest);  // 퀘스트 제목 비교
      };
        

  // 랜덤 퀘스트를 사용자 스킬 기반으로 선택하는 함수
  const getRandomQuestForUser = (skills) => {
    let availableQuests = [];
  
    // 각 스킬에 맞는 퀘스트 목록 가져오기
    skills.forEach(skillArray => {
      const skill = skillArray[0];  // 스킬 이름 추출 (첫 번째 값)
      const skillQuests = getRandomQuest(skill);  // 스킬에 맞는 퀘스트 목록 가져오기
      availableQuests = [...availableQuests, ...skillQuests];
    });
  
    // 이미 수행 중인 퀘스트 제거 로직
    const filteredQuests = availableQuests.filter(quest => !isQuestInProgress(quest));
  
    // 랜덤으로 하나의 퀘스트 선택
    return filteredQuests[Math.floor(Math.random() * filteredQuests.length)];
  };
  

  // 로딩 상태 처리
  if (loading) {
    return <p>Loading...</p>;
  }


  // 퀘스트 클릭 핸들러

  // 퀘스트 클릭 시 세부 정보 요청
// 퀘스트 클릭 시 세부 정보 요청
const fetchQuestDetails = async (questTitle) => {
  try {
      const encodedTitle = encodeURIComponent(questTitle);  // 한글 및 공백을 인코딩
      const response = await axios.get(`${apiUrl}/quest/details/${encodedTitle}/`);  // title 기반 API 요청
      setQuestDetails(prev => ({
          ...prev,
          [questTitle]: response.data.details
      }));
  } catch (error) {
      console.error('퀘스트 세부 정보 요청 실패:', error);
  }
};

//// 퀘스트 생성하러가기 버튼
const handleCreateQuest = () => {
  navigate('/create_quest');  // 페이지 이동
};
//////////  퀘스트 생성하러가기 버튼 끝.


  // 퀘스트 클릭 시 처리
  const toggleQuestDetails = (index, quest) => {
    console.log("Selected quest:", quest);  // 클릭된 퀘스트 로그 출력
    setActiveQuest(activeQuest === index ? null : index);  // 활성화 상태 토글
    if (!questDetails[quest]) {  // 이미 세부 정보를 요청한 적이 없을 때만 API 요청
      fetchQuestDetails(quest);
    }
  };

  // 내용 제한 23자
  const truncateText = (text, maxLength) => {
    if (!text) return '';  // text가 undefined이거나 null일 경우 빈 문자열 반환
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  ///////// 퀘스트 목록 클릭 (진행 중) 끝. 






//// 진행 중 탭 부분 시작

  // 진행 중인 퀘스트 가져오는 함수
  const fetchInProgressQuests = async () => {
    const token = localStorage.getItem('accessToken');
    
    try {
      const response = await axios.get(`${apiUrl}/quest/quest_userquestlog/inprogress_with_details/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("Fetched in-progress quests:", response.data);  // 여기에서 응답 데이터를 출력
      return response.data;  // 진행 중인 퀘스트와 세부 정보 반환
    } catch (error) {
      console.error('Error fetching in-progress quests and details:', error);
      return [];
    }
  };

  // // 퀘스트 포기 처리 함수
  // const handleGiveUpQuest = async () => {
  //   const token = localStorage.getItem('accessToken');
    
  //   try {
  //     // API 요청으로 상태를 'give_up'으로 변경
  //     const response = await axios.patch(
  //       `${apiUrl}/quest/quest_userquestlog/${selectedQuestId}/give_up/`, 
  //       {},
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     console.log('Quest 상태 변경됨:', response.data);
      
  //     // 상태가 변경되었으므로 진행 중 퀘스트 목록 갱신
  //     const updatedQuests = await fetchInProgressQuests();
  //     setInProgressQuests(updatedQuests);
      
  //     // 모달창 닫기
  //     closeModal();
      
  //   } catch (error) {
  //     console.error('Error giving up quest:', error);
  //   }
  // };
  const handleGiveUpQuest = async () => {
    const token = localStorage.getItem('accessToken');
  
    try {
      // API 요청으로 상태를 'give_up'으로 변경
      const response = await axios.patch(
        `${apiUrl}/quest/quest_userquestlog/${selectedQuestId}/give_up/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('Quest 상태 변경됨:', response.data);
  
      // 캐시 데이터 삭제
      const formattedDate = format(new Date(), 'yyyy-MM-dd');
      localStorage.removeItem(`quests_${formattedDate}`);
  
      // 진행 중인 퀘스트 목록 갱신 (옵션)
      const updatedQuests = await fetchInProgressQuests();
      setInProgressQuests(updatedQuests);
  
      // 모달창 닫기
      closeModal();
    } catch (error) {
      console.error('퀘스트 포기 실패:', error.response ? error.response.data : error.message);
    }
  };
  
  
  




  // 모달창 열기 (퀘스트 포기 버튼 클릭 시)
  const openModal = (questId) => {
    setSelectedQuestId(questId); // 선택된 퀘스트 ID 저장
    setShowModal(true); // 모달창 열기
  };

  // 모달창 닫기
  const closeModal = () => {
    setShowModal(false); // 모달창 닫기
    setModalContent(false)
    setSelectedQuestId(null); // 선택된 퀘스트 초기화
  };

  

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 진행 중 탭 부분 끝.



// // 완료된 퀘스트 클릭 핸들러
// const handleCompletedQuestClick = (questId) => {
//   const selectedQuest = completedQuests.find(quest => quest.id === questId);
//   setSelectedCompletedQuest(selectedQuest);
// };

// 결과 확인 모달창
const handleStepClick = async (step) => {
  try {
    console.log("Step data:", step); // 클릭한 데이터 확인

    // API 요청
    const response = await axios.get(`${apiUrl}/quest/report/`, {
      params: {
        title: step.title, // 클릭된 step의 title 전달
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });

    console.log("API response data:", response.data); // 응답 확인

    // 응답 데이터를 모달에 설정
    setModalContent({
      title: step.title,
      description: step.description,
      tip: response.data.content || "작성된 후기가 없습니다.",
    });
    setShowReviewModal(true); // 모달창 열기
  } catch (error) {
    console.error("Error fetching quest report:", error);
    setModalContent({
      title: step.title,
      description: step.description,
      tip: "작성된 후기가 없습니다.",
    });
    setShowReviewModal(true); // 기본 모달창 열기
  }
};





// const handleCompletedQuestClick = async (questId) => {
//   try {
//     const response = await axios.get(`${apiUrl}/quest/completed/${questId}/`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
//       },
//     });
//     setSelectedCompletedQuest(response.data); // 세부 정보 저장
//     // console.log(selectedCompletedQuest); // 데이터 구조 확인
//     console.log(response.data); // 데이터 구조 확인
//   } catch (error) {
//     console.error('Error fetching quest details:', error);
//   }
// };


const handleCompletedQuestClick = async (questId) => {
  try {
    const response = await axios.get(`${apiUrl}/quest/completed/${questId}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    setSelectedCompletedQuest(response.data); // 세부 정보 저장
    // setModalContent(true); // 모달창 열기
  } catch (error) {
    console.error('Error fetching quest details:', error);
  }
};




////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 완료 탭 부분 끝.

  return (
    <div className={styles.questPage}>
      <h1 className={styles.BIGtitle}>Quest</h1>
      <div className={styles.navTabs}>
        {/* '시작 가능' 탭 */}
        <div
          className={`${styles.navTab} ${activeTab === 'available' ? styles.active : ''}`}
          onClick={() => setActiveTab('available')}
        >
          시작 가능
        </div>
        {/* '진행 중' 탭 */}
        <div
          className={`${styles.navTab} ${activeTab === 'inprogress' ? styles.active : ''}`}
          onClick={() => setActiveTab('inprogress')}
        >
          진행 중
        </div>
        {/* '완료' 탭 */}
        <div
          className={`${styles.navTab} ${activeTab === 'completed' ? styles.active : ''}`}
          onClick={() => setActiveTab('completed')}
        >
          완료
        </div>
      </div>
  
      {/* 시작 가능 퀘스트 탭 내용 */}
      {activeTab === 'available' && (
        <>
          {/* <h1 className={styles.title}>시작 가능 퀘스트</h1> */}
          <p className={styles.titlep}>시작 가능 퀘스트</p>
          <div className={styles.questList}>
            {randomQuests.map((quest, index) => (
              <div 
                key={index} 
                className={`${styles.questItem} ${activeQuest === index ? styles.selectedQuest : ''}`} 
                onClick={() => toggleQuestDetails(index, randomQuests[index])}
              >
                {/* 퀘스트 제목 클릭 시 세부 내용 표시 */}
                <div className={styles.questTitle} onClick={() => toggleQuestDetails(index, randomQuests[index])}>
                  <span>{truncateText(quest, 21)}</span>  {/* 21자 제한 후 "..." 출력 */}
                  <span className={styles.expandIcon}>
                    {activeQuest === index ? '▲' : '▼'}
                  </span>
                </div>
  
                {/* 클릭된 퀘스트만 세부 내용과 버튼을 표시 */}
                {activeQuest === index && (
                  <div className={styles.questDetails}>

  
                    {questDetails[quest] ? questDetails[quest].map((detail, idx) => (
                      <div key={idx} className={styles.questDetailItem}>
                        <p>1일차 : {detail.title}</p>
                        <p>{detail.description}</p>
                      </div>
                    )) : <p className={styles.questDetailItem}>세부 정보 로딩 중...</p>}

                    <button className={styles.startQuestButton} onClick={handleCreateQuest}>
                      퀘스트 생성하기 페이지로 이동
                    </button>

                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
  
      {/* 진행 중 퀘스트 탭 내용 */}
      {/* 진행 중 퀘스트 탭 내용 */}
      {activeTab === 'inprogress' && (
        <>
          <p className={styles.titlep}>진행 중 퀘스트</p>
          <div className={styles.questList}>
            {inProgressQuests.length > 0 ? (
              inProgressQuests.map((questItem, index) => (
                <div 
                  key={index} 
                  className={`${styles.questItem} ${activeQuest === index ? styles.selectedQuest : ''}`}
                  onClick={() => setActiveQuest(activeQuest === index ? null : index)}
                >
                  <div className={styles.questTitle}>
                    <span>{truncateText(questItem.quest?.title || '제목 없음', 21)}</span>
                    <span className={styles.expandIcon}>
                      {activeQuest === index ? '▲' : '▼'}
                    </span>
                  </div>

                  {activeQuest === index && (
                    <div className={styles.questDetails}>
                      {questItem.quest_detail ? (
                        <div className={styles.questDetailItem}>
                          <p>{questItem.quest_detail.title}</p>
                          <p>{questItem.quest_detail.description}</p>
                          {/* <p>{questItem.id}</p> */}
                        </div>
                      ) : (
                        <p>세부 정보 없음</p>
                      )}
                      
                      {/* '퀘스트 포기하기' 버튼 추가 */}
                      <button 
                        className={styles.giveUpButton} 
                        onClick={() => openModal(questItem.id)}

                      >
                        퀘스트 포기하기
                      </button>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p>진행 중인 퀘스트가 없습니다.</p>
            )}
          </div>
        </>
      )}

      {/* 모달창 구현 */}
      {showModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h2>정말 퀘스트를 포기하실건가요?</h2>
            <p>퀘스트를 포기하면, <br />해당 퀘스트가 더이상 진행되지 않습니다.</p>
            <div className={styles.modalButtons}>
              <button className={styles.leftButton} onClick={handleGiveUpQuest}>
                포기하기
              </button>
              <button className={styles.rightButton} onClick={closeModal}>
                이어하기
              </button>
            </div>
          </div>
        </div>
      )}
      
  
      {activeTab === 'completed' && (
  <>
    {selectedCompletedQuest ? (
      // 완료된 퀘스트 세부 정보 렌더링
      <div className={styles.questDetailPage}>
        <button onClick={() => setSelectedCompletedQuest(null)} className={styles.backButton}>
          <img src={BACKBTN} alt="뒤로 가기 버튼" className={styles.backButtonImage} />
        </button>
        <h1>{selectedCompletedQuest.quest_title}</h1> {/* 퀘스트 타이틀 */}

        {selectedCompletedQuest.quest_details.map((step, index) => (
      <div
      key={index}
      className={`${styles.questStep} ${
        step.status === "completed"
          ? styles.completed
          : step.status === "failed"
          ? styles.failed
          : styles.inProgress
      }`}
      onClick={() => step.status === "completed" && handleStepClick(step)} // 상태가 "성공"일 때만 호출
      >
      <div className={styles.questHeader}>
        <span
          className={`${styles.status} ${
            step.status === 'completed'
              ? styles.statusCompleted
              : styles.statusFailed
          }`}
        >
        {step.status === 'completed' ? '성공' : '실패'}
        </span>
        <p className={styles.dayTitle}>
          {step.day}일 차 : {step.title}
        </p>
      </div>

      <p className={styles.descriptionp}>{step.description}</p>
    </div>
  ))}

{showReviewModal && modalContent && (
  <div className= {styles.modalBackdrop}>
    <div className={styles.modalContent}>
      <button className={styles.closeButton} onClick={closeModal}>✕</button>
      <h1 className={styles.modalTitle}>{modalContent.title}</h1>
      {/* <h2 className={styles.modalSubtitle}>퀘스트 내용</h2> */}
      <p className={styles.modalDescription}>{modalContent.description}</p>
      {/* <p>{modalContent.</p> */}
      
      <h3 className={styles.modalReviewTitle}>후기 내용</h3>
      <textarea
        className={styles.modalTextarea}
        value={modalContent.tip || "팁이 없습니다."}
        readOnly
      />
      <button className={styles.modalButton} onClick={closeModal}>완료</button>
    </div>
  </div>
)}

      </div>
    ) : (
      // 완료된 퀘스트 목록 렌더링
      <>
        <p className={styles.titlep}>완료된 퀘스트</p>
        <div className={styles.questList}>
          {completedQuests.length > 0 ? (
            completedQuests.map((questItem, index) => (
              <div
                key={index}
                className={styles.questItem}
                onClick={() => handleCompletedQuestClick(questItem.id)} // 클릭 시 세부 정보 표시
              >
                <div className={styles.questTitle}>
                  <span>{questItem.title || '제목 없음'}</span>
                  <span className={styles.expandIcon}>▶</span>
                </div>
              </div>
            ))
          ) : (
            <p>완료된 퀘스트가 없습니다.</p>
          )}
        </div>
      </>
    )}
  </>
)}


      {/* 퀘스트 생성하러 가기 버튼 */}
      <button onClick={handleCreateQuest} className={styles.createQuestButton}>
              +
      </button>
    </div>
  );
  
};

export default QuestPage;